import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { ProductListBusinessService } from './resources/product-list-business.service';

const routes: Routes = [
  createRoute({
    path: '',
    component: ProductListComponent,
    init: ProductListBusinessService,
  }),
  createRoute({
    path: 'details/:id',
    component: ProductDetailsComponent,
    leave: true
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BuilderSetupProductRoutingModule {}

